/** Inline tag next to the product name; inline-block so the strike-through skips it. */
export function ZeroQtyTag() {
  return (
    <span className="ml-2 inline-block rounded bg-red-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-700">
      Qty 0
    </span>
  );
}
